module.exports = __webpack_public_path__ + "img/password.acaf3a15.png";